import React, { Component, useContext, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import {
  Button,
  ClickAwayListener,
  Grid,
  Paper,
  Popper,
  Switch,
  Tooltip,
  Typography,
} from '@material-ui/core';
import FullScreenDialog from '../../scenes/ExpenseTracking/components/FullScreenDialog';
import {
  mdiArrowExpand,
  mdiChevronDown,
  mdiChevronUp,
  mdiExpandAll,
  mdiInformationSlabCircleOutline,
} from '@mdi/js';
import Icon from '@mdi/react';
import theme from 'components/theme';

const styles = (theme) => ({
  root: {
    ...theme.component.dashboardPaper,
    //padding: theme.spacing(2),
    margin: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      maxHeight: 'calc((100vh - 96px))',
    },
    [theme.breakpoints.down('sm')]: {
      maxHeight: '350px',
    },
    minHeight: '0px',
    overflow: 'auto',
    borderRadius: theme.spacing(1),
  },
  root_nolimit: {
    ...theme.component.dashboardPaper,
    padding: theme.spacing(2),
    margin: theme.spacing(1),
    marginTop: theme.spacing(0),
    overflow: 'auto',
    borderRadius: theme.spacing(1),
    borderTopLeftRadius: 0,
  },
  icon: {
    fontSize: '.9em',
  },
  iconButton: {},
  expandIconContainer: {
    textAlign: 'right',
  },
  title: {
    // marginTop: 0,
    // marginBottom: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
  sticky: {
    ...theme.component.dashboardPaper,
    position: 'sticky',
    top: 0,
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    zIndex: 998,
  },
  padded: {
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
});

const ActionContainer = (props) => {
  const {
    classes,
    children,
    color,
    required,
    title = 'No title',
    titleIcon,
    titleIconAlign = 'left',

    closable,
    closableSwitch,
    open = false,
    setOpen = () => {},

    expandable,
    expanded = false,
    setExpanded = () => {},

    info,

    onAction,
    actionIcon,

    popperIcon,
    popperChildren,
    onPopper,
  } = props;

  const [expandedState, setExpandedState] = useState(expanded);
  const [openState, setOpenState] = useState(open);

  const [popperAnchor, setPopperAnchor] = useState(null);

  useEffect(() => {
    setOpenState(open);
    setExpandedState(expanded);
  }, [expanded, open]);

  const onOpenChange = (value) => {
    setOpenState(value);
    setOpen(value);
  };

  const onExpandChange = (value) => {
    setExpandedState(value);
    setExpanded(value);
  };

  const onOpenPopper = (event) => {
    event.stopPropagation();
    setPopperAnchor(event.currentTarget);
  };

  const onClickPopper = (e) => {
    setPopperAnchor(null);
    onPopper(e);
  };

  return (
    <>
      <FullScreenDialog
        title={title}
        open={expandable && expandedState}
        dialogName={title}
        onClose={() => onExpandChange(false)}
        collapse
      >
        <Grid
          container
          spacing={1}
          style={{
            padding: 10,
            ...props.style,
          }}
        >
          {children}
        </Grid>
      </FullScreenDialog>
      <Grid
        container
        style={{
          marginTop: 10,
          padding: 10,
          borderRadius: 10,
          backgroundColor: theme.palette.primary[color],
          ...props.style,
        }}
      >
        <Grid container onClick={() => onOpenChange(!openState)} spacing={1}>
          <Grid
            item
            xs
            container
            direction="row"
            alignItems="center"
            style={{ display: 'flex' }}
            zeroMinWidth
          >
            {titleIcon && titleIconAlign === 'left' && (
              <Grid item xs="auto">
                {titleIcon}
              </Grid>
            )}
            <Grid item xs>
              <Typography noWrap className={classes.title}>
                {title}
                {required && ' *'}
                {titleIcon && titleIconAlign === 'right' && titleIcon}
              </Typography>
            </Grid>
          </Grid>

          {info && (
            <Grid item xs="auto" className={classes.expandIconContainer}>
              <Tooltip title={info}>
                <IconButton
                  className={classes.iconButton}
                  color="inherit"
                  size="small"
                >
                  <Icon
                    path={mdiInformationSlabCircleOutline}
                    size={1}
                    className={classes.icon}
                  />
                </IconButton>
              </Tooltip>
            </Grid>
          )}

          {expandable && (
            <Grid item xs="auto" className={classes.expandIconContainer}>
              <IconButton
                className={classes.iconButton}
                color="inherit"
                onClick={() => onExpandChange(true)}
                size="small"
              >
                <Icon path={mdiArrowExpand} size={1} className={classes.icon} />
              </IconButton>
            </Grid>
          )}
          {actionIcon && (
            <Grid item xs="auto" className={classes.expandIconContainer}>
              <IconButton
                className={classes.iconButton}
                color="inherit"
                size="small"
                onClick={onAction}
              >
                {actionIcon}
              </IconButton>
            </Grid>
          )}
          {popperIcon && (
            <Grid item xs="auto" className={classes.expandIconContainer}>
              <IconButton
                className={classes.iconButton}
                color="inherit"
                size="small"
                onClick={onOpenPopper}
              >
                {popperIcon}
              </IconButton>
              <Popper
                placement="bottom"
                style={{ zIndex: 10000 }}
                open={Boolean(popperAnchor)}
                anchorEl={popperAnchor}
              >
                <ClickAwayListener onClickAway={() => setPopperAnchor(null)}>
                  <Paper style={{ display: 'grid' }}>
                    <Button onClick={onClickPopper}>{popperChildren}</Button>
                  </Paper>
                </ClickAwayListener>
              </Popper>
            </Grid>
          )}
          {closable && (
            <Grid item xs="auto" className={classes.expandIconContainer}>
              {closableSwitch ? (
                <Switch
                  checked={openState}
                  onChange={() => onOpenChange(!openState)}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
              ) : (
                <IconButton
                  className={classes.iconButton}
                  color="inherit"
                  onClick={() => onOpenChange(!openState)}
                  size="small"
                >
                  <Icon
                    path={openState ? mdiChevronUp : mdiChevronDown}
                    size={1}
                    className={classes.icon}
                  />
                </IconButton>
              )}
            </Grid>
          )}
        </Grid>
        {(!closable || openState) && (
          <Grid
            container
            spacing={1}
            style={{
              padding: 10,
            }}
          >
            {children}
          </Grid>
        )}
      </Grid>
    </>
  );
};

ActionContainer.defaultProps = {
  required: false,
  title: 'No title',
  titleIconAlign: 'left',
  closable: false,
  open: false,
  setOpen: () => {},
  expandable: false,
  expanded: false,
  setExpanded: () => {},
  info: '',
  children: null,
  color: 'dark',
  switchable: false,
};

ActionContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  required: PropTypes.bool,
  children: PropTypes.node,
  title: PropTypes.string,
  titleIcon: PropTypes.node,
  closable: PropTypes.bool,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  expandable: PropTypes.bool,
  expanded: PropTypes.bool,
  setExpanded: PropTypes.func,
  info: PropTypes.string,
  color: PropTypes.string,
  onAction: PropTypes.func,
  actionIcon: PropTypes.node,
  popperIcon: PropTypes.node,
  popperChildren: PropTypes.node,
  onPopper: PropTypes.func,
  switchable: PropTypes.bool,
};

export default withStyles(styles)(ActionContainer);
